import React, { Fragment, useState } from "react";
import { Btn, H6, P } from "../../../../../AbstractElements";
import { SmallModals } from "../../../../../Constant";
import CommonModal from "../../Common/CommonModal";
import { ChevronsRight } from "react-feather";
import { SMALL_DATA } from "../../../../../Data/UiKit/Modal";

const SmallModal = () => {
  const [smallScreen, setSmallScreen] = useState(false);
  const smallScreenToggle = () => setSmallScreen(!smallScreen);
  return (
    <>
      <Btn color="primary" type="button" onClick={smallScreenToggle}>{SmallModals}</Btn>
      <CommonModal size="sm" isOpen={smallScreen} toggle={smallScreenToggle} sizeTitle="Small modal" modalBodyClassName="dark-modal">
        <div className="large-modal-header"><ChevronsRight /><H6>Web Design </H6></div>
        <P className="modal-padding-space mb-0">We build specialised websites for companies, list them on digital directories, and set up a sales funnel to boost ROI.</P>
        {SMALL_DATA.map(({ title, text }, index) => (
          <Fragment key={index}>
            <div className="large-modal-header"><ChevronsRight /><H6 className="ps-1">{title}</H6></div>
            <P className="modal-padding-space">{text}</P>
          </Fragment>
        ))}
      </CommonModal>
    </>
  );
};

export default SmallModal;
